import { Text, Code, Label, FormattedDateTime } from '@customerio/pluma-components/react';
import type { SearchResult } from '@/services/auth/types';
import { MetadataRow } from './metadata-row';

type Props = { result: Extract<SearchResult, { kind: 'email_layout' }> };

export function EmailLayoutPreview({ result }: Props) {
  // services sends `archived` as the string "true"/"false". Only surface a badge when archived —
  // an active layout is the unremarkable default, and an unrecognised value falls through to no badge.
  const isArchived = result.other.archived === 'true';

  return (
    <>
      <MetadataRow label="ID">
        <Code size="xs">{result.other.id}</Code>
      </MetadataRow>
      {isArchived ? (
        <MetadataRow label="Status">
          <Label color="grey">Archived</Label>
        </MetadataRow>
      ) : null}
      <MetadataRow label="Created">
        <Text size="xs">
          <FormattedDateTime className="fs-mask" date={result.other.created_at} format="medium" />
        </Text>
      </MetadataRow>
      <MetadataRow label="Updated">
        <Text size="xs">
          <FormattedDateTime className="fs-mask" date={result.other.updated_at} format="medium" />
        </Text>
      </MetadataRow>
    </>
  );
}
